
<div :class="chartClass" ref="Chart">
    <div class="ChartsWrap" v-if="chartType === 'pie' && secondValues.length > 0">
        <div class="ChartContainer">
            <h2 v-if="displayTitle" v-html="displayTitle || '<br />'" />
            <apexchart
                v-if="chartOptions && series.length"
                :type="chartType"
                :height="chartHeight"
                :width="chartWidth"
                :options="chartOptions"
                :series="series"
            />
        </div>
        <div class="ChartContainer">
            <h2 v-if="title" v-html="secondValuesTitle || '<br />'" />
            <apexchart
                v-if="secondChartOptions && secondSeries.length"
                :type="chartType"
                :height="chartHeight"
                :width="chartWidth"
                :options="secondChartOptions"
                :series="secondSeries"
            />
        </div>
    </div>

    <div class="ChartsWrap" v-else-if="renderSeparately && secondValues.length > 0">
        <div class="ChartContainer">
            <h2 v-if="displayTitle" v-html="displayTitle || '<br />'" />
            <apexchart
                v-if="chartOptions && series.length"
                :type="chartType"
                :height="chartHeight"
                :width="chartWidth"
                :options="chartOptions"
                :series="series"
            />
        </div>
        <div class="ChartContainer">
            <h2 v-if="title" v-html="secondValuesTitle || '<br />'" />
            <apexchart
                v-if="secondChartOptions && secondSeries.length"
                :type="chartType"
                :height="chartHeight"
                :width="chartWidth"
                :options="secondChartOptions"
                :series="secondSeries"
            />
        </div>
    </div>

    <!-- Horizontally scrollable bar chart for mobile -->
    <div
        v-else-if="isMobile && chartType === 'bar' && !renderSeparately && !secondValues.length"
        class="ChartScrollX"
    >
        <h2>
            {{ displayTitle }}
            <slot></slot>
        </h2>
        <apexchart
            v-if="chartOptions && series.length"
            :type="chartType"
            :height="chartHeight"
            :width="scrollChartWidth"
            :options="chartOptions"
            :series="series"
        />
    </div>

    <!-- Default (desktop or non-bar) -->
    <div v-else>
        <h2>
            {{ displayTitle }}
            <slot></slot>
        </h2>
        <!-- Legend for chart annotations -->
        <div v-if="showAnnotationLegend" class="chart-legend">
            <div class="legend-item">
                <span class="legend-color" style="background-color: #09d490"></span>
                <span class="legend-label">Max Tagesumsatz</span>
            </div>
            <div class="legend-item">
                <span class="legend-color" style="background-color: #f7d01c"></span>
                <span class="legend-label">Ø Tagesumsatz</span>
            </div>
        </div>
        <apexchart
            v-if="chartOptions && series.length"
            :type="chartType"
            :height="chartHeight"
            :width="chartWidth"
            :options="chartOptions"
            :series="series"
            @dataPointSelection="handleDataPointSelection"
            @click="handleChartClick"
        />
    </div>
</div>
